export enum EnumWhereMeetCaju {
  SOCIAL_MEDIA_POST = "Posts em redes sociais (Linkedin, Instagram, Youtube etc)",
  INTERNET_SEARCH = "Estava buscando soluções na internet",
  BLOG_CONTENT = "Li conteúdos do blog",
  CORPORATE_EVENT = "Conheci em um evento",
  EMPLOYEE_RECOMMENDATION = "Indicação de colaboradores da minha empresa",
  COLLEAGUE_RECOMMENDATION = "Indicação de colegas de outras empresas",
  PRESS_NEWS = "Notícias na imprensa",
}
